// @ts-nocheck
// Greif UI Kit = line-orders
import React from "react";

const OrdersLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.981 4.629h.006c.408.033.763.302.902.694l3.724 10.485a3 3 0 0 1 1.428.599l6.816-2.728h.003a1.044 1.044 0 0 1 1.346.614 1.05 1.05 0 0 1-.61 1.351v.001L14.16 18.23q.054.276.055.569a3.01 3.01 0 0 1-3.003 3.02 3.01 3.01 0 0 1-3.003-3.02c0-1.054.538-1.982 1.351-2.521l-3.39-9.55H3.772c-.541 0-.986-.414-1.04-.944l-.006-.107c0-.58.469-1.052 1.046-1.052H6.91zm4.23 13.097c-.59 0-1.067.481-1.067 1.074s.478 1.073 1.067 1.073c.59 0 1.068-.48 1.068-1.073a1.07 1.07 0 0 0-1.068-1.074"
                clipRule="evenodd"
            />
            <path
                fill="currentColor"
                d="m13.674 12.857 3.885-1.421-2.627-7.26-3.885 1.422zm5.763-1.926a1.78 1.78 0 0 1-1.055 2.276l-4.206 1.538a1.763 1.763 0 0 1-2.262-1.062L9.17 6.103a1.777 1.777 0 0 1 1.055-2.275l4.206-1.539a1.76 1.76 0 0 1 2.262 1.061z"
            />
        </svg>
    );
};

export default React.memo(OrdersLine);
